import { useQuery } from "@apollo/react-hooks";
import { GET_NOTE_SUGGESTIONS } from "../api/spending";

// 依所選分類取得歷史備註（常用且近期優先），供表單自動完成。
// 建議查詢失敗時靜默降級成無建議，不影響表單本身的使用。
export default (categoryId) => {
  const { data } = useQuery(GET_NOTE_SUGGESTIONS, {
    variables: { categoryId },
    fetchPolicy: "cache-and-network",
    onError() {},
  });

  return (data && data.noteSuggestions) || [];
};
